var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_c('EditInventoryListTargeting',{staticClass:"wrap",attrs:{"list":_vm.list,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }